import { ref as o, computed as t, onMounted as d, onBeforeUnmount as s } from "vue";
const n = o([]), r = t(() => n.value.includes("social")), e = () => {
  n.value = window?.utag?.gdpr?.getSelectedCategories?.() || [];
}, a = () => {
  d(() => {
    window.addEventListener("consentChanged", e), window.addEventListener("load", e), e();
  }), s(() => {
    window.removeEventListener("consentChanged", e), window.removeEventListener("load", e);
  });
};
export {
  e as consentChanged,
  n as consentGiven,
  r as isSocialConsentGiven,
  a as registerConsent
};
